import { frontendURL } from '../../../helper/URLHelper';
import CmsIndex from './pages/CmsIndex.vue';
import ThemeIndex from './pages/ThemeIndex.vue';
import AnalyticsIndex from './pages/AnalyticsIndex.vue';
import DomainIndex from './pages/DomainIndex.vue';
import SeoIndex from './pages/SeoIndex.vue';
import ProductsIndex from './pages/ProductsIndex.vue';
import ProductCategoriesIndex from './pages/ProductCategoriesIndex.vue';
import ManufacturersIndex from './pages/ManufacturersIndex.vue';
import ShopsIndex from './pages/ShopsIndex.vue';
import OrdersIndex from './pages/OrdersIndex.vue';
import BlogIndex from './pages/BlogIndex.vue';
import FormsIndex from './pages/FormsIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/website/cms'),
    name: 'website_cms_index',
    component: CmsIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/website/theme'),
    name: 'website_theme_index',
    component: ThemeIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/website/analytics'),
    name: 'website_analytics_index',
    component: AnalyticsIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/website/domain'),
    name: 'website_domain_index',
    component: DomainIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/website/seo'),
    name: 'website_seo_index',
    component: SeoIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/website/products'),
    name: 'website_products_index',
    component: ProductsIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/website/product-categories'),
    name: 'website_product_categories_index',
    component: ProductCategoriesIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/website/manufacturers'),
    name: 'website_manufacturers_index',
    component: ManufacturersIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/website/shops'),
    name: 'website_shops_index',
    component: ShopsIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/website/orders'),
    name: 'website_orders_index',
    component: OrdersIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/website/blog'),
    name: 'website_blog_index',
    component: BlogIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/website/forms'),
    name: 'website_forms_index',
    component: FormsIndex,
    meta: commonMeta,
  },
];
